import { motion } from "framer-motion";
import { ArrowRight, MessageCircle, Sparkles } from "lucide-react";
import { AIDashboard } from "@/components/AIDashboard";
import { BRAND } from "@/lib/constants";

export const Hero = () => {
  return (
    <section id="home" data-testid="hero-section" className="relative pt-28 md:pt-32 pb-16 md:pb-24 overflow-hidden hero-radial">
      <div className="absolute inset-0 grid-bg opacity-40 pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div>
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 mb-6"
            >
              <Sparkles size={14} className="text-[#D4AF37]" />
              <span className="text-[11px] uppercase tracking-[0.22em] text-white/80">AI-Powered · India</span>
            </motion.div>

            <motion.h1
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.05 }}
              className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter leading-[1.05] text-white"
            >
              Helping Indian Businesses generate more{" "}
              <span className="gold-gradient-text">leads, sales</span> &{" "}
              <span className="gold-gradient-text">faster growth</span> with AI-Powered Digital Marketing.
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.15 }}
              className="mt-6 text-base sm:text-lg text-white/70 leading-relaxed max-w-xl"
            >
              VR Marketing Hub helps businesses grow through Meta Ads, Facebook Ads, Instagram Ads, AI Content Creation, AI Video Editing, Landing Pages, Lead Generation, Social Media Marketing, Website Development and Creative Branding.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.25 }}
              className="mt-8 flex flex-col sm:flex-row gap-3"
            >
              <a
                href="#lead-form"
                data-testid="hero-cta-primary"
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-[#D4AF37] hover:bg-[#F3E5AB] text-[#050B14] text-sm font-semibold transition-all shadow-[0_10px_40px_-10px_rgba(212,175,55,0.6)]"
              >
                Book FREE Strategy Call
                <ArrowRight size={16} />
              </a>
              <a
                href={BRAND.whatsappLink}
                target="_blank"
                rel="noreferrer"
                data-testid="hero-cta-whatsapp"
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-white/[0.04] hover:bg-white/[0.08] border border-white/15 text-white text-sm font-semibold transition-colors"
              >
                <MessageCircle size={16} className="text-emerald-400" />
                Chat on WhatsApp
              </a>
            </motion.div>

            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.7, delay: 0.4 }}
              className="mt-10 grid grid-cols-3 gap-6 max-w-md"
            >
              {[
                { k: "AI", v: "Powered" },
                { k: "100%", v: "Transparent" },
                { k: "24×7", v: "Support" },
              ].map((s) => (
                <div key={s.k}>
                  <div className="text-xl font-bold text-white">{s.k}</div>
                  <div className="text-[11px] uppercase tracking-[0.18em] text-[#D4AF37] mt-1">{s.v}</div>
                </div>
              ))}
            </motion.div>
          </div>

          <div className="relative">
            <AIDashboard />
          </div>
        </div>
      </div>
    </section>
  );
};
